import React, { useEffect, useState } from 'react';
import { CloudUpload } from 'lucide-react';
import { listQueue, OFFLINE_QUEUE_CHANGED } from '../lib/offlineQueue';

export const PendingForCantiere = ({ cantiereId }) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const refresh = () =>
      listQueue().then((all) => setItems(all.filter((i) => i.url.includes(`/cantieri/${cantiereId}/`)))).catch(() => {});
    refresh();
    window.addEventListener(OFFLINE_QUEUE_CHANGED, refresh);
    return () => window.removeEventListener(OFFLINE_QUEUE_CHANGED, refresh);
  }, [cantiereId]);

  if (!items.length) return null;
  return (
    <div data-testid="pending-cantiere-notice" className="mb-4 rounded-lg border border-blue-200 bg-blue-50 p-3 text-sm text-blue-900">
      <p className="flex items-center gap-2 font-medium">
        <CloudUpload className="w-4 h-4 shrink-0" />
        Da inviare quando torna la rete ({items.length}):
      </p>
      <ul className="mt-1 ml-6 list-disc">
        {items.map((i) => (
          <li key={i.id} className="break-words">{i.label}{i.status !== 'pending' && ' — da controllare'}</li>
        ))}
      </ul>
    </div>
  );
};

export default PendingForCantiere;
